export const INTERACTIVE_FOCUS =
	"[transition:opacity_400ms_cubic-bezier(0.4,0,0.2,1),color_400ms_cubic-bezier(0.4,0,0.2,1),background-color_400ms_cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-500 focus-visible:outline-offset-[3px]";
